// A person's dish order on the pad (backend routes/pad_prefs.py): one list over the whole
// menu, saved against the person and shared by every till in the venue.

/**
 * The whole saved order with one tab's dishes put in their new order, in the places they
 * already held. `saved` is the order as positions ({ id: index }); `menuIds` the dishes this
 * pad shows; `tabIds` the tab's dishes in their new order.
 *
 * The whole order starts from what's saved, not from the dishes this pad shows: the bar's pad
 * shows only drinks, and saving from it used to drop the places of every dish it doesn't
 * show (the kids' menu, a section switched off for the night).
 */
export function mergeTabOrder(saved, menuIds, tabIds) {
  const known = Object.entries(saved || {}).sort((a, b) => a[1] - b[1]).map(([id]) => id);
  const seen = new Set(known);
  const all = [...known, ...menuIds.filter((id) => !seen.has(id))];
  const inTab = new Set(tabIds);
  const queue = [...tabIds];
  return all.map((id) => (inTab.has(id) ? queue.shift() : id));
}

/** Move an order kept in this browser (from before the till kept it) across to the till?
 *  Only for someone who has never saved one there: after a Reset, another till's old copy
 *  must not bring the old order back. */
export const shouldMigrate = (server, local) => !server?.saved && !(server?.item_ids || []).length
  && Array.isArray(local) && local.length > 0;
